import script from "./EmployeesListView.vue?vue&type=script&setup=true&lang=js"
export * from "./EmployeesListView.vue?vue&type=script&setup=true&lang=js"

import "./EmployeesListView.vue?vue&type=style&index=0&id=7373e42e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7373e42e"]])

export default __exports__